/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Share_Share_ActionInputs */

const en_us2_workout_share_share_action = /** @type {(inputs: Workout_Share_Share_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share`)
};

const pt_br2_workout_share_share_action = /** @type {(inputs: Workout_Share_Share_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar`)
};

const es_419_workout_share_share_action = /** @type {(inputs: Workout_Share_Share_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir`)
};

const pt_pt2_workout_share_share_action = /** @type {(inputs: Workout_Share_Share_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partilhar`)
};

const fr_fr2_workout_share_share_action = /** @type {(inputs: Workout_Share_Share_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager`)
};

const de_de2_workout_share_share_action = /** @type {(inputs: Workout_Share_Share_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen`)
};

const it_it2_workout_share_share_action = /** @type {(inputs: Workout_Share_Share_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi`)
};

/**
* | output |
* | --- |
* | "Share" |
*
* @param {Workout_Share_Share_ActionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_share_action = /** @type {((inputs?: Workout_Share_Share_ActionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Share_ActionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_share_action(inputs)
	if (locale === "es-419") return es_419_workout_share_share_action(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_share_action(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_share_action(inputs)
	if (locale === "de-DE") return de_de2_workout_share_share_action(inputs)
	if (locale === "it-IT") return it_it2_workout_share_share_action(inputs)
	return en_us2_workout_share_share_action(inputs)
});
export { workout_share_share_action as "workout-share.share_action" }